import styled from "styled-components";

export const Container = styled.div`
  display: flex;
`;

export const Content = styled.div`
  margin: 25px 15px;
  width: 100%;
`;
